import { z } from "zod";
import { FORM_ERROR_MESSAGES } from "@shared/constants";
import { Meeting, MeetingStatus } from "@shared/models";
import { CreateUserMeetingDto, CreateUserMeetingFormShape } from "@containers/User/interfaces/UserForm.interface";
import { Option } from "@shared/interfaces";

export const MEETING_STATUS_OPTIONS: Option<string>[] = [
  { value: "Scheduled", label: "Scheduled" },
  { value: "Conducted", label: "Conducted" },
];

export const validationSchema = z.object({
  title: z.string().min(1, FORM_ERROR_MESSAGES.REQUIRED).max(100, `Meeting ${FORM_ERROR_MESSAGES.LONG}`),
  date: z.string().refine((value) => !Number.isNaN(new Date(value).getTime()), FORM_ERROR_MESSAGES.REQUIRED),
  comment: z.string().min(1, FORM_ERROR_MESSAGES.REQUIRED).max(200, `Comment ${FORM_ERROR_MESSAGES.LONG}`),
  add_to_google_calendar: z.string(),
  status: z.string(),
}) satisfies z.ZodType<CreateUserMeetingFormShape>;

export const getInitValues = (meeting: Meeting | null): CreateUserMeetingFormShape => ({
  title: meeting?.title || "",
  date: meeting?.date ? new Date(String(meeting?.date)).toISOString().substring(0, 10) : "",
  comment: meeting?.comment || "",
  add_to_google_calendar: meeting?.add_to_google_calendar ? "1" : "0",
  status: meeting?.status || MeetingStatus.SCHEDULED,
});

export const prepareSubmitValue = (
  values: CreateUserMeetingFormShape,
): Omit<CreateUserMeetingDto, "contractor_id"> => ({
  ...values,
  date: new Date(String(values.date)),
  add_to_google_calendar: Boolean(Number(values.add_to_google_calendar)),
});
